(() => {
  angular
    .module('app.report')
    .controller('AffinityReportController', AffinityReport);

  AffinityReport.$inject = [
    '$scope',
    '$cookies',
    '$timeout',
    '$filter'
  ];

  function AffinityReport(
    $scope,
    $cookies,
    $timeout,
    $filter
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    let isVisibilityWatcherSetted = false;
    let cache = {};
    let maxAffinity = 0;

    const { report } = $scope.$parent;
    const vm = this;

    vm.getReportItem = ri => report.campaign.reportItems.find(item => item.evid === ri.evid);
    vm.isTVEnabled = reportItem => {
      const ri = vm.getReportItem(reportItem);
      return ri && ri.properties.featureTVEnabled === 1;
    };

    vm.getSampleSizeErrorLevel = reportItem => reportItem.nStatus;
    vm.getSampleSizeErrorTooltip = reportItem => {
      switch (vm.getSampleSizeErrorLevel(reportItem)) {
        case 'warning': return `Sample size is ${reportItem.n}. That seems a bit low!`;
        case 'error': return 'No sample size - please check the implementation!';
        default: return `Sample size is ${$filter('number')(reportItem.n)}`;
      }
    };
    vm.isStandard = () => report.campaign && report.campaign.type === 'standard';
    vm.getProvider = provider => report.getProvider(provider);

    activate();
    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      report.reportPromise.then((response) => {
        cache.report = response.data;
        vm.loaded = true;
      }).then(() => {
        report.isCampaignLoading = false;
        report.isCampaignLoaded = true;

        if (document.visibilityState === 'visible') {
          updateDataOnVisible();
        } else {
          if (!isVisibilityWatcherSetted) {
            document.addEventListener('visibilitychange', updateDataOnVisible);
            isVisibilityWatcherSetted = true;
          }
        }
      });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      //load saved preferences for limit
      if (_.isUndefined($cookies.getObject('curLimitShowing'))) $cookies.putObject('curLimitShowing', 2);
      if (_.isUndefined($cookies.getObject('limit'))) $cookies.putObject('limit', 100000);
      vm.limit = $cookies.getObject('limit');
      vm.curLimitShowing = $cookies.getObject('curLimitShowing');

      updateTable();
    }

    function updateTable() {
      if (vm.details && cache.report) {
        var allAffinities = [
          ...getReportItems(),
          cache.report.totals,
        ];

        allAffinities.forEach(item => {
          const row = [
            ...vm.details.reportItems,
            vm.details.totals,
          ].find(curr => (
            (curr.tailcode && (curr.tailcode === item.tailcode)) ||
            (curr.fusionId && (curr.fusionId === item.fusionId)) ||
            (curr.name === 'Total')
          ));

          // update existing rows for splash animation
          if (row) {
            row.trp = item.trp;
            row.share = item.share;
            row.events = item.events;
            row.affinity = item.affinity;
            row.targetEvents = item.targetEvents;
          }
        });

        // delay for odometer splash animation
        $timeout(() => {
          vm.details = cache.report.affinityDetails || cache.report;
          updateGraph();
        }, TIME.DATA_SPLASH);
      } else {
        vm.details = cache.report;
        updateGraph();
      }

      // invalidate table after splash animation finished
      $timeout(() => {
        const dtTable = $('#tableAffinityDetails').DataTable();
        dtTable.cells().invalidate('dom').draw();
      }, TIME.DATA_SPLASH);
    }

    function updateGraph() {
      vm.total = vm.details.totals ? vm.details.totals.affinity : undefined;
      vm.ris = cache.report.reportItems;

      let allAffinities = [];
      if (cache.report.totals) {
        allAffinities = getReportItems().concat([cache.report.totals]);
        maxAffinity = _.max(allAffinities, item => item.affinity).affinity;
      }
    }

      function getReportItems() {
          if (!cache.report) {
              return [];
          }

          return cache.report.reportItems || [];
      }

    vm.percentage = v => v ? (v / maxAffinity) * 100 : 0;

    vm.showTpByAffinity = (top, newLimit) => {
      $cookies.putObject('curLimitShowing', top);
      vm.curLimitShowing = top;

      $cookies.putObject('limit', newLimit);
      vm.limit = newLimit;
    };
  }

})();
